import PropTypes from "prop-types";

// @mui material components
import { Grid } from "@mui/material";
import { Controller } from "react-hook-form";

// Material Dashboard 2 PRO React components
import MDBox from "../../../../../components/MDBox";
import MDTypography from "../../../../../components/MDTypography";

import FormField from "../FormField";
import { FormControl, Select, InputLabel, MenuItem } from "@mui/material";

function OtherInfo({ control, errors }) {

  return (
    <MDBox>
      <MDTypography variant="h5" mb={3}>
        Información adicional
      </MDTypography>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={12}>
          <Controller
            name="section"
            control={control}
            render={({ field }) => (
              <FormControl fullWidth variant="outlined" error={!!errors.section}>
                <InputLabel id="section-label">Sección</InputLabel>
                <Select
                  {...field}
                  labelId="section-label"
                  label="Sección"
                  value={field.value}
                  sx={{ height: 56 }}
                >
                  <MenuItem value="inicio">Inicio</MenuItem>
                  <MenuItem value="articulo">Artículo</MenuItem>
                  <MenuItem value="lateral">Barra lateral</MenuItem>
                  <MenuItem value="pie">Pie</MenuItem>
                  <MenuItem value="todo">Todo</MenuItem>
                </Select>

                {errors.section && (
                  <MDTypography variant="caption" color="error" ml={2} mt={0.5}>
                    {errors.section.message}
                  </MDTypography>
                )}
              </FormControl>
            )}
          />
        </Grid>

        <Grid item xs={12} sm={12}>
          <Controller
            name="url"
            control={control}
            render={({ field }) => (
              <FormField
                {...field}
                label="URL de Destino"
                error={!!errors.url}
                helperText={errors.url?.message}
              />
            )}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <Controller
            name="startDate"
            control={control}
            render={({ field }) => (
              <FormField
                {...field}
                label="Fecha de inicio"
                type="date"
                InputLabelProps={{ shrink: true }}
                error={!!errors.startDate}
                helperText={errors.startDate?.message}
              />
            )}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <Controller
            name="endDate"
            control={control}
            render={({ field }) => (
              <FormField
                {...field}
                label="Fecha de finalización"
                type="date"
                InputLabelProps={{ shrink: true }}
                error={!!errors.endDate}
                helperText={errors.endDate?.message}
              />
            )}
          />
        </Grid>
      </Grid>
    </MDBox>
  );
}

OtherInfo.propTypes = {
  control: PropTypes.isRequired,
  errors: PropTypes.isRequired,
};

export default OtherInfo;
